import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LimitOffsetPaging } from 'app/core/models/paged-results/limit-offset-paging.model';
import { ClientEncounterTypeEligibility } from 'app/core/models/client-encounter-type-eligibility.model';
import { ClientEncounterTypeEligibilityListComponent } from 'app/shared/components/client-encounter-type-eligibility-list/client-encounter-type-eligibility-list.component';
import { PaginationHeaderComponent } from 'app/shared/components/pagination-header/pagination-header.component';
import { PaginationComponent } from 'app/shared/components/pagination/pagination.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-client-encounter-type-eligibility-table',
  templateUrl: './client-encounter-type-eligibility-table.component.html',
  styleUrls: ['./client-encounter-type-eligibility-table.component.scss'],
  imports: [
    ClientEncounterTypeEligibilityListComponent,
    PaginationHeaderComponent,
    PaginationComponent,
    MatProgressSpinner,
  ],
})
export class ClientEncounterTypeEligibilityTableComponent {
  @Input() paging: LimitOffsetPaging;
  @Input() loading: boolean;
  @Input() clientEncounterTypeEligibilities: ClientEncounterTypeEligibility[];
  @Input() label: string;

  @Output() pageSizeChange = new EventEmitter<number>();
  @Output() pageChange = new EventEmitter<number>();
}
